module.exports = __webpack_public_path__ + "tc.svg?b4bb9eb97bc9a08134d10995b78f9d67";